<template>
  <div>
    <section data-aos="fade-up">
         <picture>
        <source media="(max-width: 768px)" srcset="@/assets/img/md/fidc/fidc-bg-1.png">
        <source media="(min-width: 768px)" srcset="@/assets/img/lg/fidc/fidc-bg-1.png">
        <img src="@/assets/img/lg/fidc/fidc-bg-1.png"  class="image-width-100"/>
      </picture>
    </section>

    <!-- 行业背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <h1 class="title-main text-align-center pb-4 color-black font-weight-500">行业背景</h1>
        <retract-list :dataList="industryList"></retract-list>
      </div>
    </section>

    <!-- 现状 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1 text-align-center fff-background" data-aos="fade-up">
      <div class="container">
        <h1 class="title-main pb-4 color-black font-weight-500">现状</h1>
        <span class="title-sub">工厂主流系统间的数据割裂，严重阻碍企业效率，消除系统壁垒意义重大。</span>
        <div class="row pt-4">
          <div v-for = "item in currentList" :key="item.title" class="col-lg-6 col-md-6 col-12">
            <img :src="item.src" class="image-width-100" />
            <span class="font-weight-600 color-dark-grey title-sub">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- FIDC概念图 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1 text-align-center" data-aos="fade-up">
      <div class="container">
        <h1 class="title-main pb-4 color-black lg-hidden font-weight-500">FIDC概念图</h1>
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/fidc/fidc-bg-2.png">
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/fidc/fidc-bg-2.png">
          <img src="@/assets/img/lg/fidc/fidc-bg-2.png"  class="image-width-100 fidc-image"/>
        </picture>
        <div class="lg-hidden fidc-desc text-align-left color-light-grey text-line-height-2">
          <p v-for="item in dataList" :key="item" class="green-point">{{ item }}</p>
        </div>
      </div>
    </section>

    <!-- FIDC产品地图 -->
    <section class="pt-4 pb-4 text-line-height-1 text-align-center" data-aos="fade-up">
      <div class="container">
        <h1 class="title-main pb-4 color-black font-weight-500">FIDC产品地图</h1>
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/fidc/fidc-bg-3.png">
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/fidc/fidc-bg-3.png">
          <img src="@/assets/img/lg/fidc/fidc-bg-3.png"  class="image-width-100 "/>
        </picture>
      </div>
    </section>

    <!-- FIDC案例 -->
    <section class="pt-4 pb-4 text-line-height-1 text-align-center" data-aos="fade-up">
      <div class="container">
        <h1 class="title-main pb-4 color-black font-weight-500">FIDC案例</h1>
        <div class="row plf-swiper">
          <div class="swiper-fidc-box swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in bannerList" :key="'fidc'+index">
                <img :src="item.src"  class="image-width-100" />
              </div>
            </div>
            <!-- <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div> -->
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min.js'
export default {
  name: 'Fidc',
  components: { },
  props: {},
  data() {
    return {
      // 行业背景
      industryList: [
        '近现代历史证明，强国唯一的道路就是发展制造业。',
        '在此背景下，围绕实现制造强国的战略目标，国务院于2015年5月发布了《中国制造2025》，明确制造业强国的五大工程和十大领域。智能制造作为五大工程之一，成为国家全力打造制造强国的重要途径。',
        '推进工厂信息化建设，则是推进智能制造的关键。降低生产成本；压缩库存积压；提高工作效率和管理水平都是信息化管理系统正在发挥的积极作用，所以说，一个工厂拥有了完善的信息管理系统是每一个共产迈向智能制造的必经之路。',
      ],
      // 现状
      currentList: [
        {
          src: require("@/assets/img/common/fidc/status1.png"),
          title: '以为完美融合'
        },
        {
          src: require("@/assets/img/common/fidc/status2.png"),
          title: '实际割裂'
        },
      ],
      dataList: ['Factory inner-data circulation', '工厂数据内循环', '消费已有生产数据，产生新价值数据'],
      bannerList: [
        {
          src: require('@/assets/img/common/caseList/electromagneticVehicle/banner1.png'),
        },
        {
          src: require('@/assets/img/common/caseList/muBang/banner1.png'),
        },
        {
          src: require('@/assets/img/common/caseList/platForm/banner2.png'),
        },
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {
    new Swiper('.swiper-fidc-box', {
      speed: 600,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // }
    });
  },
}
</script>
<style scoped>
@media (max-width: 768px){
  .fidc-image{
    padding: 0 4rem;
  }
  .plf-swiper{
    padding: 0 3rem;
  }
}
@media (min-width: 768px){
  .fidc-image{
    padding: 0;
  }
  .plf-swiper {
    padding: 0 15rem;
  }
}
.fidc-desc{
  padding: 0 4rem;
}

</style>